import {CALL_API} from 'redux-api-middleware';
import {
  DYNAMIC_COMPONENT_DEPENDENCY_GET_REQUEST,
  DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS,
  DYNAMIC_COMPONENT_DEPENDENCY_GET_FAILURE,
  COLLABORATION_ENTER_ROOM_FETCH_SUCCESS,
} from 'common/types';
import {
  ENDPOINT_REFDATA,
  ENDPOINT_GRANT,
  ENDPOINT_ORGANIZATION,
  ENDPOINT_FUNDING_OPPORTUNITY,
  ENDPOINT_CONFIGURATION,
  ENDPOINT_INVOICE,
  ENDPOINT_OBLIGATION,
  ENDPOINT_CLOSEOUT,
  ENDPOINT_PROGRAM,
  ENDPOINT_COMMITMENT,
  ENDPOINT_COMMENT,
  ENDPOINT_WORKFLOW,
  ENDPOINT_WORKFLOW_TASK,
  ENDPOINT_PANEL_REVIEW_APPLICATION,
  ENDPOINT_PANEL_REVIEW_SCORES,
  ENDPOINT_ATTACHMENT,
  ENDPOINT_DYNAMIC_DATA,
  ENDPOINT_RULES,
  ENDPOINT_TEMPLATES,
  ENDPOINT_USER,
  ENDPOINT_VENDOR,
  ENDPOINT_SEARCH,
  ENDPOINT_PANEL_V2,
  ENDPOINT_PANEL_V2_SESSION,
  ENDPOINT_EHP,
  ENDPOINT_PRESCORE_V2,
  ENDPOINT_DISASTER,
  ENDPOINT_ALLOCATION,
  ENDPOINT_ORGANIZATION_RELATIONSHIP,
} from 'common/endpoints';

import {commonJwtHeader} from 'common/utils';
import {getToggledEndpoint, isRoomManagedPath} from 'common/storeUtils';
import goStore from 'go/store';

const dependencyEndpoints = {
  allocationsByFO: ENDPOINT_ALLOCATION,
  allocation: ENDPOINT_ALLOCATION,
  allocationEntities: ENDPOINT_DYNAMIC_DATA,
  allocationEntitiesByTypes: ENDPOINT_DYNAMIC_DATA,
  allocationPendingEntities: ENDPOINT_WORKFLOW,
  communityLifeline: ENDPOINT_REFDATA,
  hazardSources: ENDPOINT_REFDATA,
  fundingSources: ENDPOINT_REFDATA,
  fundingTypes: ENDPOINT_REFDATA,
  structureTypes: ENDPOINT_REFDATA,
  propertyOwnerTypes: ENDPOINT_REFDATA,
  propertyInventoryTypes: ENDPOINT_REFDATA,
  benefitCostTypes: ENDPOINT_REFDATA,
  mitigationActionTypes: ENDPOINT_REFDATA,
  propertyFoundationTypes: ENDPOINT_REFDATA,
  floodZoneTypes: ENDPOINT_REFDATA,
  natureBasedSolutions: ENDPOINT_REFDATA,
  grant: ENDPOINT_GRANT,
  organization: ENDPOINT_ORGANIZATION,
  subOrganization: ENDPOINT_ORGANIZATION,
  subOrganizationBySubOrgId: ENDPOINT_ORGANIZATION,
  subOrganizationsForGrant: ENDPOINT_ORGANIZATION,
  organizations: ENDPOINT_ORGANIZATION,
  fundingOpportunity: ENDPOINT_FUNDING_OPPORTUNITY,
  fundingOpportunityV2: ENDPOINT_CONFIGURATION,
  fosByOrgAndSubOrg: ENDPOINT_FUNDING_OPPORTUNITY,
  programCategoryConfig: ENDPOINT_CONFIGURATION,
  invoice: ENDPOINT_INVOICE,
  obligation: ENDPOINT_OBLIGATION,
  obligationStatus: ENDPOINT_OBLIGATION,
  approvedObligationAmount: ENDPOINT_OBLIGATION,
  subGrantObligationAmountsByGrant: ENDPOINT_OBLIGATION,
  closeout: ENDPOINT_CLOSEOUT,
  program: ENDPOINT_PROGRAM,
  programDefaultConfig: ENDPOINT_PROGRAM + 'finalProgramConfig/',
  commitment: ENDPOINT_COMMITMENT,
  commitmentDataForGrant: ENDPOINT_SEARCH,
  comment: ENDPOINT_COMMENT,
  subComment: ENDPOINT_COMMENT,
  rfaComment: ENDPOINT_COMMENT,
  riskAssessment: ENDPOINT_ORGANIZATION,
  workflowTask: ENDPOINT_WORKFLOW_TASK,
  panelReview: ENDPOINT_PANEL_REVIEW_APPLICATION,
  scores: ENDPOINT_PANEL_REVIEW_SCORES,
  panelReviewScoresV2: ENDPOINT_PANEL_V2 + 'sessions/',
  panelReviewUserScoresV2: ENDPOINT_PANEL_V2 + 'sessions/',
  panelReviewFinalScoresV2: ENDPOINT_PANEL_V2 + 'finalscore/',
  panelReviewSessionsV2: ENDPOINT_PANEL_V2 + 'sessions',
  panelReviewV2: ENDPOINT_PANEL_V2,
  prescoreV2: ENDPOINT_PRESCORE_V2,
  fundingOpportunityData: ENDPOINT_FUNDING_OPPORTUNITY,
  awardRecommendation: ENDPOINT_DYNAMIC_DATA + 'grant/',
  awardRecommendationForFO: ENDPOINT_DYNAMIC_DATA + 'fundingOpportunityId/',
  subAwardRecommendation: ENDPOINT_DYNAMIC_DATA + 'grant/',
  subAwardRecommendationForFO: ENDPOINT_DYNAMIC_DATA + 'fundingOpportunityId/',
  subAwardRecommendationsForGrant: ENDPOINT_DYNAMIC_DATA + 'grant/',
  subAmendmentRecommendation: ENDPOINT_DYNAMIC_DATA + 'grant/',
  subAmendmentRecommendationsForGrant: ENDPOINT_DYNAMIC_DATA + 'grant/',
  subAwardOrAmendmentRecommendation: ENDPOINT_DYNAMIC_DATA + 'grant/',
  subAmendmentRecommendationsForSubGrant: ENDPOINT_DYNAMIC_DATA + 'subGrant/',
  subApplicationFromSubGrantId: ENDPOINT_DYNAMIC_DATA + 'subGrant/',
  subCloseoutReportsForGrant: ENDPOINT_DYNAMIC_DATA + 'grant/',
  subCloseoutRecommendationsForGrant: ENDPOINT_DYNAMIC_DATA + 'grant/',
  legacyHMASubAmendmentRecommendationsForSubGrant: ENDPOINT_SEARCH,
  attachment: ENDPOINT_ATTACHMENT,
  rules: ENDPOINT_RULES,
  applicationDynamicData: ENDPOINT_DYNAMIC_DATA + 'grant/',
  awardRecommendationDynamicDataRaw: ENDPOINT_DYNAMIC_DATA + 'grant/',
  workflowTasksForGrant: ENDPOINT_WORKFLOW_TASK,
  workflowTasksForSubGrant: ENDPOINT_WORKFLOW_TASK,
  templates: ENDPOINT_TEMPLATES,
  subGrant: ENDPOINT_DYNAMIC_DATA + 'entity/',
  subGrantWithConfigPath: ENDPOINT_DYNAMIC_DATA + 'entity/',
  subGrantsForGrant: ENDPOINT_DYNAMIC_DATA + 'grant/',
  subApplication: ENDPOINT_DYNAMIC_DATA + 'entity/',
  subApplicationWithConfigPath: ENDPOINT_DYNAMIC_DATA + 'entity/',
  subApplicationGrant: ENDPOINT_DYNAMIC_DATA + 'grant/',
  subApplicationsForGrant: ENDPOINT_DYNAMIC_DATA + 'grant/',
  subApplicationProgram: ENDPOINT_PROGRAM,
  loadItemCodes: ENDPOINT_REFDATA,
  loadRefApplicantType: ENDPOINT_REFDATA,
  loadStates: ENDPOINT_REFDATA,
  user: ENDPOINT_USER,
  amendment: ENDPOINT_DYNAMIC_DATA + 'entity/',
  financialReport: ENDPOINT_DYNAMIC_DATA + 'entity/',
  bsirReport: ENDPOINT_DYNAMIC_DATA + 'entity/',
  performanceProgressReport: ENDPOINT_DYNAMIC_DATA + 'entity/',
  closeoutReport: ENDPOINT_DYNAMIC_DATA + 'entity/',
  closeoutReports: ENDPOINT_DYNAMIC_DATA + 'entity/',
  closeoutRecommendation: ENDPOINT_DYNAMIC_DATA + 'grant/',
  programmaticCloseoutReview: ENDPOINT_DYNAMIC_DATA + 'entity/',
  payment: ENDPOINT_DYNAMIC_DATA + 'entity/',
  loadProgramCategories: ENDPOINT_REFDATA,
  ehpData: ENDPOINT_DYNAMIC_DATA + 'entity/',
  ehpRecommendationData: ENDPOINT_DYNAMIC_DATA + 'entity/',
  ehpReviewData: ENDPOINT_EHP + 'review/',
  ehpReviewsForSubGrant: ENDPOINT_EHP + 'reviews/',
  payments: ENDPOINT_DYNAMIC_DATA + 'grant/',
  paymentsForSubGrant: ENDPOINT_DYNAMIC_DATA + 'subGrant/',
  amendments: ENDPOINT_DYNAMIC_DATA + 'grant/',
  grantApplicationExtensions: ENDPOINT_FUNDING_OPPORTUNITY + 'grant/',
  vendor: ENDPOINT_VENDOR,
  landUseTypes: ENDPOINT_REFDATA,
  getForGrant: ENDPOINT_DYNAMIC_DATA + 'grant/',
  getForSubGrant: ENDPOINT_DYNAMIC_DATA + 'subGrant/',
  applicationLinkData: ENDPOINT_SEARCH,
  applicationsByOrg: ENDPOINT_DYNAMIC_DATA,
  grantIdByFOIdAndOrgId: ENDPOINT_DYNAMIC_DATA,
  panelReviewSessionEntityTasks: ENDPOINT_WORKFLOW_TASK,
  panelReviewSessionUserTasks: ENDPOINT_WORKFLOW_TASK,
  panelReviewReviewerNames: ENDPOINT_USER,
  panelReviewSession: ENDPOINT_PANEL_V2_SESSION,
  panelReviewAssignedEntities: ENDPOINT_PANEL_V2 + 'sessions/',
  panelReviewV2Endpoint: ENDPOINT_PANEL_V2 + 'sessions/',
  rfi: ENDPOINT_DYNAMIC_DATA + 'entity/',
  rfis: ENDPOINT_DYNAMIC_DATA + 'subGrant/',
  returnOfFund: ENDPOINT_DYNAMIC_DATA + 'entity/',
  rofsForGrant: ENDPOINT_DYNAMIC_DATA + 'grant/',
  rofsForSubGrant: ENDPOINT_DYNAMIC_DATA + 'subGrant/',
  rfisForAmendment: ENDPOINT_SEARCH,
  rfisForParentEntity: ENDPOINT_SEARCH,
  activeRfisForParentEntity: ENDPOINT_SEARCH,
  completeRfiUserTask: ENDPOINT_DYNAMIC_DATA + 'entity/',
  panelReviewEntity: ENDPOINT_DYNAMIC_DATA + 'grant/',
  disasterAreas: ENDPOINT_DISASTER + 'declaration/',
  disaster: ENDPOINT_DISASTER + 'declaration/',
  taskData: ENDPOINT_DYNAMIC_DATA + 'grant/',
  fundingOpportunityOrganizationData: ENDPOINT_ORGANIZATION_RELATIONSHIP,
  subCloseoutReport: ENDPOINT_DYNAMIC_DATA + 'grant/',
  subCloseoutReports: ENDPOINT_DYNAMIC_DATA + 'subGrant/',
  subCloseoutRecommendation: ENDPOINT_DYNAMIC_DATA + 'grant/',
  fundingOpportunityDraft: ENDPOINT_FUNDING_OPPORTUNITY + 'draft/',
  subRecipientMgmtCost: ENDPOINT_SEARCH,
  subCloseoutRecommendationForGrant: ENDPOINT_DYNAMIC_DATA + 'grant/',
};

export default {
  get: (
    objectType,
    id,
    jwt,
    optional,
    extraArgs = '', // really should be able to merge extraArgs into the id argument, they're the same thing
    otherArgs = {} // don't add anymore arguments or else, just put them in this object
  ) => {
    const {contextName, method, body, inPayloadObj} = otherArgs;
    const state = goStore.store.getState();
    const endpoint = getToggledEndpoint(state, dependencyEndpoints[objectType]);
    const roomArgs = {
      objectType,
      id,
      jwt,
      optional,
      extraArgs,
      contextName,
      method,
      body,
      inPayloadObj,
      endpoint,
      fullEndpoint: `${endpoint}${id}` + extraArgs,
      storePath: `context.${contextName || objectType}`,
    };
    let dependencySuccessType = DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS;
    if (isRoomManagedPath(state, roomArgs)) {
      dependencySuccessType = COLLABORATION_ENTER_ROOM_FETCH_SUCCESS;
    }
    return {
      [CALL_API]: {
        endpoint: `${endpoint}${id}` + extraArgs,
        method: method || 'GET',
        headers: commonJwtHeader(),
        types: [
          {
            type: DYNAMIC_COMPONENT_DEPENDENCY_GET_REQUEST,
            meta: {objectType: contextName || objectType, optional: optional},
          },
          {
            type: dependencySuccessType,
            meta: {
              objectType: contextName || objectType,
              optional: optional,
              inPayloadObj,
            },
          },
          {
            type: DYNAMIC_COMPONENT_DEPENDENCY_GET_FAILURE,
            meta: {objectType: contextName || objectType, optional: optional},
          },
        ],
        body: JSON.stringify(body),
      },
    };
  },
};
